module.exports = __webpack_public_path__ + "static/media/intro-1.660fb8df.svg";